import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

import { persistLocale } from '../../functions/persistLocale'
import { StoreButtons } from './StoreButtons'
import s from './landing.module.css'

/** Nomes nativos dos idiomas do site (mesmos do app). */
const LANGUAGE_NAMES: Record<string, string> = {
  pt: 'Português',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  ar: 'العربية',
  he: 'עברית',
  zh: '中文',
}

/** Seletor de idioma do footer (Saira Condensed sobre o ink). */
function LanguageSelect() {
  const router = useRouter()
  const { locales, locale, pathname, query, asPath } = router

  if (!locales || locales.length < 2) return null

  return (
    <select
      aria-label="Idioma / Language"
      value={locale}
      onChange={(event) => {
        persistLocale(event.target.value)
        router.push({ pathname, query }, asPath, {
          locale: event.target.value,
        })
      }}
      style={{
        background: 'transparent',
        color: 'rgba(255,255,255,.85)',
        border: '2px solid rgba(255,255,255,.3)',
        borderRadius: 999,
        padding: '6px 14px',
        fontFamily: "'Saira Condensed', sans-serif",
        fontSize: 13,
        letterSpacing: '.1em',
        textTransform: 'uppercase',
        cursor: 'pointer',
      }}
    >
      {locales.map((code) => (
        <option key={code} value={code} style={{ color: '#141414' }}>
          {LANGUAGE_NAMES[code] || code}
        </option>
      ))}
    </select>
  )
}

/** CTA final vermelho: o tatame te espera + botões das lojas. */
export function FinalCta() {
  const { t } = useTranslation('landing')

  return (
    <section
      className="bg-brand"
      id="baixar"
      style={{
        padding: '130px 7vw',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        className={s.stripes}
        style={{
          position: 'absolute',
          width: 160,
          height: 110,
          insetInlineStart: '6vw',
          top: 60,
          color: '#fff',
        }}
        aria-hidden="true"
      />
      <div
        className={s.stripes}
        style={{
          position: 'absolute',
          width: 160,
          height: 110,
          insetInlineEnd: '6vw',
          bottom: 60,
          color: '#fff',
        }}
        aria-hidden="true"
      />
      <h2
        className={`${s.d} text-white`}
        style={{ fontSize: 'clamp(64px,10vw,170px)' }}
      >
        <span className={s.outW}>{t('cta.title1')}</span>
        <br />
        {t('cta.title2')}
      </h2>
      <p
        className={s.lead}
        style={{
          margin: '22px auto 0',
          maxWidth: 520,
          color: 'rgba(255,255,255,.85)',
        }}
      >
        {t('cta.lead')}
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          flexWrap: 'wrap',
          marginTop: 38,
        }}
      >
        <StoreButtons />
      </div>
      <div
        className={`${s.d} text-white`}
        style={{ fontSize: 30, marginTop: 44 }}
      >
        OSS
      </div>
    </section>
  )
}

/** Footer ink: wordmark, tagline e links institucionais. */
export function LandingFooter() {
  const { t } = useTranslation('landing')

  return (
    <footer
      className={`bg-section-black ${s.foot}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 16,
        padding: '36px 7vw',
      }}
    >
      <span className={s.wordmark}>Goodfellas</span>
      <span
        className={s.cond}
        style={{
          fontSize: 13,
          letterSpacing: '.18em',
          color: 'rgba(255,255,255,.85)',
        }}
      >
        {t('footer.tagline')}
      </span>
      <span
        className={s.cond}
        style={{
          fontSize: 13,
          letterSpacing: '.14em',
          display: 'flex',
          gap: 18,
        }}
      >
        <a href="#topo">{t('footer.platforms')}</a>
        <Link href="/termos">{t('footer.terms')}</Link>
        <Link href="/privacidade">{t('footer.privacy')}</Link>
      </span>
      <LanguageSelect />
    </footer>
  )
}
